import JSGroupsIntro from "../../../../contents/docs/_snippets/groups-intro.mdx";
import JSGroupsVSCohorts from "../../../../contents/docs/_snippets/groups-vs-cohorts.mdx";
import JSCreateGroups from "../../../../contents/docs/_snippets/how-to-create-groups.mdx";
import JSSetGroupProperties from "../../../../contents/docs/_snippets/setting-group-properties.mdx";
import JSLinkEventsToGroups from "../../../../contents/docs/_snippets/how-to-link-events-to-groups.mdx";
import viewGroupLight from "../../../../contents/images/docs/user-guides/group-analytics/view-groups-light-mode.png";
import viewGroupDark from "../../../../contents/images/docs/user-guides/group-analytics/view-groups-dark-mode.png";
import relatedLight from "../../../../contents/images/docs/user-guides/group-analytics/related-people-and-groups-light-mode.png";
import relatedDark from "../../../../contents/images/docs/user-guides/group-analytics/related-people-and-groups-dark-mode.png";
import groupInsightsLight from "../../../../contents/images/docs/user-guides/group-analytics/group-insights-light-mode.png";
import groupInsightsDark from "../../../../contents/images/docs/user-guides/group-analytics/group-insights-dark-mode.png";
import funnelsGroupAggregationLight from "../../../../contents/images/docs/user-guides/group-analytics/funnels-group-aggregation-light-mode.png";
import funnelsGroupAggregationDark from "../../../../contents/images/docs/user-guides/group-analytics/funnels-group-aggregation-dark-mode.png";
import groupsInFeatureLight from "../../../../contents/images/docs/user-guides/group-analytics/groups-in-feature-flags-light-mode.mp4";
import groupsInFeatureDark from "../../../../contents/images/docs/user-guides/group-analytics/groups-in-feature-flags-dark-mode.mp4";
import groupsProjectSettingLight from "../../../../contents/images/docs/user-guides/group-analytics/groups-project-settings-light-mode.png";
import groupsProjectSettingDark from "../../../../contents/images/docs/user-guides/group-analytics/groups-project-settings-dark-mode.png";
import * as React from 'react';
export default {
  JSGroupsIntro,
  JSGroupsVSCohorts,
  JSCreateGroups,
  JSSetGroupProperties,
  JSLinkEventsToGroups,
  viewGroupLight,
  viewGroupDark,
  relatedLight,
  relatedDark,
  groupInsightsLight,
  groupInsightsDark,
  funnelsGroupAggregationLight,
  funnelsGroupAggregationDark,
  groupsInFeatureLight,
  groupsInFeatureDark,
  groupsProjectSettingLight,
  groupsProjectSettingDark,
  React
};